import React from 'react'
import { Image } from '@deal/components'
import { Link } from 'react-router-dom'
import { SellableCardFragment, ConsumerSellableReactionRating } from '#src/generated/graphql'
import { formatMonetaryAmountAsJsx } from '#src/services/money'
import SellableReactions from '#src/components/SellableReactions'
import YachtCabins from '../yacht-cabins.svg'
import YachtCapacity from '../yacht-capacity.svg'
import styles from './styles.css'
import { getSellableUrl } from '#src/services/sellable'

interface FeaturedSellableProps {
  sellable?: SellableCardFragment
  onSellableRatingSelected: (sellableRating: ConsumerSellableReactionRating) => void
}

const FeaturedSellable: React.SFC<FeaturedSellableProps> = ({
  sellable,
  onSellableRatingSelected
}) => {
  if (!sellable || sellable.images.length === 0 || !sellable.department) {
    return null
  }

  return (
    <div className={styles.sellable}>
      <div className={styles.image}>
        <div className={styles.imageContainer}>
          <Link to={getSellableUrl(sellable)}>
            <div className={styles.gradientMask} />
            <Image
              src={sellable.images[0].url}
              width={655}
              height={350}
              imgixParams={{
                fit: 'crop'
              }}
              className={styles.sellableImage}
            />
          </Link>
          <div className={styles.details}>
            <div className={styles.title}>
              {sellable.charterLocation &&
                sellable.charterLocation.formatted &&
                sellable.charterLocation.formatted.displayHtml && (
                  <div
                    className={styles.location}
                    dangerouslySetInnerHTML={{
                      // Until we can fix the charter locations, this is safe enough
                      __html: sellable.charterLocation.formatted.displayHtml.split(',')[0]
                    }}
                  />
                )}

              <div className={styles.name}>
                <Link to={getSellableUrl(sellable)} className={styles.titleLink}>
                  {sellable.title}
                </Link>
              </div>
            </div>
            <div className={styles.specs}>
              {sellable.variationMatrix &&
                sellable.variationMatrix.priceRange && (
                  <div className={styles.price}>
                    From{' '}
                    <strong>
                      {formatMonetaryAmountAsJsx(sellable.variationMatrix.priceRange!.min, {
                        round: 'floor'
                      })}
                    </strong>
                  </div>
                )}
              <div className={styles.amenities}>
                {sellable.charterCabins &&
                  sellable.charterCabins.formatted && (
                    <div className={styles.amenity}>
                      <YachtCabins />{' '}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: sellable.charterCabins.formatted.displayHtml
                        }}
                      />
                    </div>
                  )}
                {sellable.charterCapacity &&
                  sellable.charterCapacity.formatted && (
                    <div className={styles.amenity}>
                      <YachtCapacity />{' '}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: sellable.charterCapacity.formatted.displayHtml
                        }}
                      />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.reactions}>
        <SellableReactions onSellableRatingSelected={onSellableRatingSelected} />
      </div>
    </div>
  )
}

export default FeaturedSellable
